/* tms-bandeau.js — le bandeau de la famille sur toute la boutique (lot 07 comptes, D1 D2 D5 D9 D10 d'Alex).

   🔴 UNE FAMILLE, CELLE DE L'APPAREIL. Le jeton vient de `localStorage tms_ma_famille` (retenu dès l'envoi par le bloc
   tms-gallery, ou rangé par tms-compte.js depuis le compte connecté, qui l'annonce par `tms:memoire`), sinon de
   l'onglet (`tms_jeton`). Il ne part jamais dans une adresse : seulement dans le CHEMIN d'un `GET` à la galerie, sans
   cookie.
   🔴 LE SONDAGE NE TOURNE QUE PENDANT L'ATTENTE : toutes les 5 s, arrêté à « prête », sur un onglet caché
   (`visibilitychange`) et au bout de 30 min de regard. Quand le bloc de la galerie sonde déjà la même famille sur la
   page (il émet `tms:famille`), le bandeau se tait et lit ses réponses : jamais deux sondages pour un seul écran.
   🔴 IL ÉMET `tms:famille` ({jeton, famille}) À CHAQUE LECTURE : le catalogue et la fiche passent à la famille sans
   recharger (D7). Les étiquettes d'attente de la page (`[data-tms-etiquette-attente]`) sont peintes ici.
   🔴 (lot 28 comptes, D1) LE CHOIX « QUI EST QUI » DIT AVANT LES PORTRAITS VOYAGE ICI : « C'est nous » mène tout de suite
   à « Tous les cadeaux », le bloc garde le choix dans `localStorage tms_qui_attente` ({jeton, membres}), et c'est le
   bandeau, qui lit déjà la famille toutes les 5 s, qui l'envoie (`POST …/qui-est-qui`) à l'arrivée des portraits. Le
   service juge le nombre (une personne par portrait) : un refus oublie le choix, et « Check names » reste proposé.
   Le bandeau ne se tait plus pendant la création (l'écran de choix boutique/Nino a disparu).
   ⚠️ Aucun texte n'est écrit ici : tout vient des `data-t-*` (bandeau et étiquettes). */
(function () {
  "use strict";

  var racine = document.querySelector("[data-tms-bandeau]");
  if (!racine) return;
  var service = (racine.dataset.service || "").replace(/\/+$/, "");
  var t = racine.dataset;
  var CLE_MEMOIRE = "tms_ma_famille";
  var CLE_FIN = "tms_bandeau_fin";
  var CLE_FERME = "tms_bandeau_ferme";
  var CLE_QUI = "tms_qui_attente";
  var SONDAGE_MS = 5000;
  var SONDAGE_MAX_MS = 30 * 60 * 1000;
  /* La page de création EST l'attente (étapes, barre, « Who's who? ») : le bandeau s'y tait. ⚠️ Seulement elle :
     l'accueil monte le même parcours dans son héros (`data-tms-montage="heros"`), et le bandeau y parle (revue). */
  var surLeParcours = !!document.querySelector('[data-tms-parcours][data-tms-montage="page"]');
  var suivi = { jeton: null, minuterie: null, depuis: 0, externe: 0, fini: false, part: 0, quiEnVol: false };

  function lire(stockage, cle) {
    try {
      return window[stockage].getItem(cle);
    } catch (e) {
      return null;
    }
  }

  function ecrire(cle, valeur) {
    try {
      window.localStorage.setItem(cle, valeur);
    } catch (e) {
      /* stockage refusé : la croix vaut pour cette page seulement */
    }
  }

  function oublierQui() {
    try {
      window.localStorage.removeItem(CLE_QUI);
    } catch (e) {
      /* stockage fermé : rien à oublier */
    }
  }

  /* 🔴 LE CHOIX GARDÉ PART UNE FOIS, quand le service peut le prendre (portraits servis) ; un choix déjà fait ailleurs
     le rend inutile. Une coupure le garde pour la lecture suivante ; un refus (400, 404…) l'oublie. */
  function envoyerQui(fam) {
    var brut = lire("localStorage", CLE_QUI);
    if (!brut || suivi.quiEnVol || !fam || !service) return;
    var choix = null;
    try {
      choix = JSON.parse(brut);
    } catch (e) {
      choix = null;
    }
    if (!choix || choix.refuse || choix.jeton !== suivi.jeton || !Array.isArray(choix.membres)) return;
    if (fam.qui_est_qui_valide || fam.etat === "échouée") return oublierQui();
    if (!fam.portraits_prets) return;
    suivi.quiEnVol = true;
    fetch(service + "/famille/" + encodeURIComponent(choix.jeton) + "/qui-est-qui", {
      method: "POST", credentials: "omit", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ membres: choix.membres }),
    })
      .then(function (r) {
        /* (revue du lot 28) 400 = le nombre ne concorde pas (un portrait a manqué) : le choix reste, marqué refusé,
           pour que « Check names » resserve ce qui a été tapé (tms-gallery.js) ; il ne repart jamais d'ici. */
        if (r.status === 400) ecrire(CLE_QUI, JSON.stringify(Object.assign({}, choix, { refuse: true })));
        else if (r.ok || (r.status > 400 && r.status < 500 && r.status !== 409 && r.status !== 429)) oublierQui();
        if (r.ok) {
          /* le choix est fait : « Check names » n'a plus lieu d'être */
          var noms = racine.querySelector("[data-tms-bandeau-noms]");
          if (noms) noms.hidden = true;
          racine.classList.remove("bandeau--noms");
        }
      })
      .catch(function () {
        /* une coupure : on réessaie à la lecture suivante */
      })
      .then(function () {
        suivi.quiEnVol = false;
      });
  }

  function substituer(modele, n) {
    return String(modele || "").split("%N%").join(String(n));
  }

  /* 🔴 L'ONGLET D'ABORD, PUIS L'APPAREIL — le même ordre que la fiche et le catalogue (revue du lot 07) : une famille
     ouverte dans cet onglet (`tms_jeton`, que le bloc y range) passe avant celle de l'appareil ; sinon le catalogue
     attendrait l'annonce d'une famille que le bandeau ne lit pas. ⚠️ Jamais l'adresse : un jeton qui y arrive est
     rangé dans l'onglet par le bloc, et le lire ici ferait une seconde lecture sur un lien pas encore vérifié. */
  function jetonDeLAppareil() {
    return lire("sessionStorage", "tms_jeton") || lire("localStorage", CLE_MEMOIRE);
  }

  function minutes(restant) {
    return Math.max(1, Math.ceil(restant / 60));
  }

  /* Les étiquettes « Your family appears here in about N min » des fiches et du catalogue (D7). */
  function peindreEtiquettes(fam) {
    var attente = !!fam && (fam.etat === "en_cours" || fam.etat === "indisponible");
    document.querySelectorAll("[data-tms-etiquette-attente]").forEach(function (n) {
      if (!attente) {
        n.hidden = true;
        return;
      }
      var r = fam.restant_estime_s;
      n.textContent = typeof r === "number" && r > 0
        ? substituer(minutes(r) === 1 ? n.dataset.tAttenteUn : n.dataset.tAttente, minutes(r))
        : n.dataset.tBientot || "";
      n.hidden = !n.textContent;
    });
  }

  function cacher() {
    racine.hidden = true;
    document.documentElement.removeAttribute("data-tms-bandeau-etat");
  }

  /* L'étape en cours : 0 Portraits · 1 Who's who? · 2 Your family · 3 tout est fait. */
  function rang(fam) {
    if (fam.etat === "prête") return 3;
    if (fam.etape === "composition") return 2;
    if (fam.etape === "scene") return 1;
    return 0;
  }

  /* 🔴 (lot 18 comptes, G4) LA PART DE L'ATTENTE DÉJÀ FAITE, en pour cent : le temps écoulé servi sur l'écoulé plus le
     reste estimé. Pleine à « prête » ; au-delà de l'estimation (`null`), presque pleine sans jamais l'être ; JAMAIS EN
     RECUL pour une même famille (un reste réestimé à la hausse ne vide pas la barre sous les yeux du visiteur). */
  function part(fam) {
    if (fam.etat === "prête") return 100;
    var ecoule = typeof fam.depuis_s === "number" ? fam.depuis_s : 0;
    var reste = fam.restant_estime_s;
    if (typeof reste === "number" && reste > 0) return Math.min(95, Math.max(3, Math.round(100 * ecoule / (ecoule + reste))));
    return "restant_estime_s" in fam && fam.etat === "en_cours" ? 95 : 3;
  }

  function peindreBarre(fam) {
    var barre = racine.querySelector("[data-tms-bandeau-barre]");
    var plein = racine.querySelector("[data-tms-bandeau-remplissage]");
    if (!barre || !plein) return;
    suivi.part = Math.max(suivi.part, part(fam));
    plein.style.width = suivi.part + "%";
    barre.setAttribute("aria-valuenow", String(suivi.part));
  }

  function peindre(fam) {
    peindreEtiquettes(fam);
    /* (lot 02 boutique-chat, D-c) une famille EXEMPLE ouverte par un lien du chat n'est pas « votre famille » : silence. */
    if (surLeParcours || !fam || fam.etat === "échouée" || fam.exemple) return cacher();
    var pret = fam.etat === "prête";
    if (lire("localStorage", CLE_FERME) === suivi.jeton || (pret && lire("localStorage", CLE_FIN) === suivi.jeton)) {
      return cacher();
    }
    var cur = rang(fam);
    racine.querySelectorAll("[data-tms-bandeau-etapes] > li").forEach(function (li, i) {
      li.classList.toggle("bandeau__etape--fait", i < cur);
      li.classList.toggle("bandeau__etape--encours", i === cur);
      if (i === cur) li.setAttribute("aria-current", "step");
      else li.removeAttribute("aria-current");
      var e = li.querySelector("[data-etat]");
      if (e) e.textContent = ", " + (i < cur ? t.tFait : i === cur ? t.tMaintenant : t.tEnsuite);
    });
    var texte;
    if (pret) {
      texte = t.tPrete;
    } else if (typeof fam.restant_estime_s === "number" && fam.restant_estime_s > 0) {
      var m = minutes(fam.restant_estime_s);
      texte = m === 1 ? t.tResteUn : substituer(t.tReste, m);
    } else if (fam.etat === "en_cours" && "restant_estime_s" in fam) {
      /* `null` servi : l'estimation est dépassée. Jamais un chiffre faux. */
      texte = t.tPresque;
    } else {
      texte = t.tAttente;
    }
    var ligne = racine.querySelector("[data-tms-bandeau-texte]");
    if (ligne && ligne.textContent !== texte) ligne.textContent = texte;
    var noms = racine.querySelector("[data-tms-bandeau-noms]");
    if (noms) noms.hidden = !!fam.qui_est_qui_valide || !(pret || fam.portraits_prets);
    racine.classList.toggle("bandeau--noms", !!noms && !noms.hidden);
    /* (lot 28 comptes) « See your products » mène à « All gifts » pendant la création aussi ; sauf sur cette page. */
    var voir = racine.querySelector("[data-tms-bandeau-voir]");
    if (voir) voir.hidden = voir.pathname === window.location.pathname;
    var nino = racine.querySelector("[data-tms-bandeau-nino]");
    if (nino) nino.hidden = pret;
    peindreBarre(fam);
    racine.setAttribute("data-etat", pret ? "prete" : "attente");
    racine.hidden = false;
    document.documentElement.setAttribute("data-tms-bandeau-etat", pret ? "prete" : "attente");
  }

  function arreter() {
    if (suivi.minuterie) window.clearTimeout(suivi.minuterie);
    suivi.minuterie = null;
  }

  function prochain() {
    arreter();
    if (suivi.fini || document.hidden || Date.now() - suivi.depuis > SONDAGE_MAX_MS) return;
    suivi.minuterie = window.setTimeout(sonder, SONDAGE_MS);
  }

  function recevoir(fam) {
    suivi.fini = !fam || fam.etat === "prête" || fam.etat === "échouée";
    envoyerQui(fam);
    peindre(fam);
  }

  function annoncer(fam) {
    /* (lot 09 comptes) la dernière annonce reste lisible pour un script qui arrive après (tms-histoire.js) */
    racine.tmsDerniere = { jeton: suivi.jeton, famille: fam };
    try {
      document.dispatchEvent(new CustomEvent("tms:famille", {
        detail: { jeton: suivi.jeton, famille: fam, source: "bandeau" },
      }));
    } catch (e) {
      /* un écouteur cassé n'arrête pas le bandeau */
    }
  }

  function sonder() {
    if (!suivi.jeton || !service) return;
    /* Le bloc de la galerie sonde la même famille sur cette page : on lit ses réponses. */
    if (Date.now() - suivi.externe < SONDAGE_MS * 1.5) return prochain();
    var jeton = suivi.jeton;
    fetch(service + "/famille/" + encodeURIComponent(jeton), { credentials: "omit" })
      .then(function (r) {
        if (r.status === 404) return { etat: "échouée" };
        return r.ok ? r.json() : null;
      })
      .then(function (fam) {
        if (jeton !== suivi.jeton) return;
        if (fam) {
          recevoir(fam);
          annoncer(fam);
        }
        prochain();
      })
      .catch(function () {
        /* une coupure n'est pas une famille perdue : on réessaie au tour suivant */
        prochain();
      });
  }

  function suivre(jeton) {
    if (!jeton || jeton === suivi.jeton) return;
    arreter();
    suivi.jeton = jeton;
    suivi.depuis = Date.now();
    suivi.fini = false;
    suivi.part = 0;
    sonder();
  }

  document.addEventListener("tms:famille", function (ev) {
    var d = ev.detail || {};
    if (d.source === "bandeau" || !d.jeton || !d.famille) return;
    if (!suivi.jeton) {
      suivi.jeton = d.jeton;
      suivi.part = 0;
    }
    if (d.jeton !== suivi.jeton) return;
    suivi.externe = Date.now();
    recevoir(d.famille);
  });
  document.addEventListener("tms:memoire", function (ev) {
    suivre(ev.detail && ev.detail.jeton);
  });
  /* (lot 25 comptes) les familles du compte viennent d'être effacées : plus rien à suivre ni à montrer. */
  document.addEventListener("tms:familles-effacees", function () {
    /* revue du lot 25 : ces deux clés portent le jeton de la famille effacée. */
    [CLE_FIN, CLE_FERME].forEach(function (cle) {
      try {
        window.localStorage.removeItem(cle);
      } catch (e) {
        /* stockage fermé : rien à oublier */
      }
    });
    arreter();
    suivi.jeton = null;
    cacher();
  });
  /* D9 : un produit avec SA famille vient d'être vu (tms-gallery.js) — le bandeau se retire tout de suite. */
  document.addEventListener("tms:produit-vu", function () {
    if (lire("localStorage", CLE_FIN) === suivi.jeton && racine.getAttribute("data-etat") === "prete") cacher();
  });
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) return arreter();
    if (suivi.jeton && !suivi.fini) {
      suivi.depuis = Date.now();
      sonder();
    }
  });

  var deplier = racine.querySelector("[data-tms-bandeau-deplier]");
  if (deplier) {
    deplier.addEventListener("click", function () {
      var ouvert = deplier.getAttribute("aria-expanded") !== "true";
      deplier.setAttribute("aria-expanded", ouvert ? "true" : "false");
      racine.classList.toggle("bandeau--deplie", ouvert);
    });
  }
  /* « Talk to Nino » : le chat de la page quand il y est (tms-chat.js écoute `tms:chat-ouvrir`), sinon le lien. */
  var lienNino = racine.querySelector("[data-tms-bandeau-nino]");
  if (lienNino) {
    lienNino.addEventListener("click", function (ev) {
      if (!document.querySelector('[data-chat="racine"]')) return;
      ev.preventDefault();
      try {
        document.dispatchEvent(new CustomEvent("tms:chat-ouvrir", { detail: {} }));
      } catch (e) {
        window.location.assign(lienNino.href);
      }
    });
  }
  var fermer = racine.querySelector("[data-tms-bandeau-fermer]");
  if (fermer) {
    fermer.addEventListener("click", function () {
      if (suivi.jeton) ecrire(CLE_FERME, suivi.jeton);
      cacher();
    });
  }

  suivre(jetonDeLAppareil());
})();
